import React, { useState } from "react";
import "./table.css";
import DataTable from 'react-data-table-component';
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { DataAPi } from "../variable/dataVariable";
import VaService from "../../services/virtualAkun.service";
import { Temporal } from '@js-temporal/polyfill';
import { Valuasi, EndPoint} from "../variable/dataVariable";


function TableVA({dataSet}) {

    const columns = [
        {
            name: 'Nomor VA',
            selector: row => row.nomorVA,
            sortable: true,
        },
        {
            name: 'Nama',
            selector: row => row.nama,
            sortable: true,
        },
        {
            name: 'Nama Kegiatan',
            selector: row => row.namaKegiatan,
            sortable: true,
        },
        {
            name: 'Kode VA',
            selector: row => row.kodeVA,
            sortable: true,
        },
        {
            name: 'Total Tagihan',
            selector: row => row.totalTagihan,
            sortable: true,
        },
        {
            name: 'Total Pembayaran',
            selector: row => row.totalPembayaran,
            sortable: true,
        },
        {
            name: 'Tanggal Pembayaran',
            selector: row => row.tanggalPembayaran,
            sortable: true,
        },
        {
            name: 'Status Pembayaran',
            selector: row => row.statusPembayaran,
            sortable: true,
        },
        {
            name: 'Menu',
            selector: row => row.menu,
            width: "190px",
        },
        
    ];

    
    const person = [];

    const setData = (customerNo, virtualAccountNo, trxId) => {
        person["customerNo"] = customerNo;
        person["virtualAccountNo"] = virtualAccountNo;
        person["trId"] = trxId;
        
    }

    const body = {     
        "partnerServiceId":"  088899",
        "customerNo": person["customerNo"],
        "virtualAccountNo": person["virtualAccountNo"],
        "trxId": person["trxId"],
        "additionalInfo":{
  
        }
    }
    const nowTime = Temporal.Now.zonedDateTimeISO().toString({ timeZoneName: 'never' });
        
    const deleteAset = (data) =>{
        VaService.signatureAuth(nowTime)
                    .then(res => {
                        VaService.accessToken(nowTime, res.signature)
                        .then(res => {
                            VaService.signatureService(res.accessToken, nowTime, EndPoint.deleteVA, data, "DELETE")
                            .then(res => {
                                VaService.servicesVA(nowTime, EndPoint.deleteVA, res.signatureService, data)
                                .then(res => {
                                    //setData(res.data)
                                })
                            })
                            .catch(err => console.log(err))
                        })
                        .catch(err => console.log(err))
                    })
                    .catch(err => console.log(err));
    }

    const data = dataSet.map((aset, index) => {
         
        return(
            {
                nomorVA: aset.virtualAccountNo,
                nama: aset.virtualAccountName,
                namaKegiatan: aset.billDetails[0].billName,
                kodeVA: aset.billDetails[0].billCode,
                totalTagihan: 'Rp. ' + aset.billDetails[0].billAmount.value,
                totalPembayaran: 'Rp. ' + aset.paidAmount.value,
                tanggalPembayaran: aset.trxDateTime,
                statusPembayaran: <div class="btn" type="text" style={{fontSize: "12px", borderColor: "green", color: "green"}} disabled>{aset.paymentFlagReason.indonesia}</div>,
                menu: <div>
                    <Link className="btn btn-primary m-1" to={`/rincianVA/${aset.customerNo}/${aset.virtualAccountNo}/${aset.additionalInfo.nama}/${aset.additionalInfo.nim}/${aset.additionalInfo.prodi}/${aset.additionalInfo.fakultas}/${aset.billDetails[0].billCode}/${aset.billDetails[0].billName}/${aset.billDetails[0].billAmount.value}/${aset.billDetails[0].billDescription.indonesia}/${aset.paidAmount.value}/${aset.trxDateTime}/${aset.referenceNo}/${aset.paymentFlagReason.indonesia}`}>
                        <i class="bi bi-file-post text-white"></i>
                    </Link>
                    <button type="button" class="btn btn-danger" onClick={() => {setData(aset.customerNo, aset.virtualAccountNo, aset.trxId)}} data-bs-toggle="modal" data-bs-target="#exampleModal">
                        <i class="bi bi-trash text-white"></i>
                    </button>

                    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h1 class="modal-title fs-5" id="exampleModalLabel">Peringatan</h1>
                                </div>
                                <div class="modal-body">
                                    Penghapusan Virtual Akun dilakukan apabila Mahasiswa tersebut Telah
                                    <br></br>
                                    menyelesaikan Seluruh Perkuliahan di UNISKI
                                    <p></p>
                                    Klik "Iya" jika anda ingin menghapus Virtua Akun
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal" onClick={() => {deleteAset(body)}}>iya</button>
                                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>,
            }
        )
    })

    const [records, setRecords] = useState(data);
    function handlerFilter(event) {
        const newData = data.filter(row => {
            return row.nama.toLowerCase().includes(event.target.value.toLowerCase())
        })
        setRecords(newData)
    }
    return(
        <div className="container table-responsive-sm bg-light m-auto border radius pb-3">
            <div className="text-end p-4">
                <input type="text" placeholder="Pencarian" onChange={handlerFilter}/>
            </div>
            <DataTable
                columns={columns}
                data={records}
                fixedHeader
                pagination
            />
        </div>
    )
}

export default TableVA;